import { IAccountModel } from "shared/model";
import { AccountType } from "../types";

export const isValidEmail = (email: string): boolean => {
	return /[a-z0-9_.+]+@([a-z0-9\-]+\.)+[a-z]{2,}/i.test(email);
};

export const isValidUsername = (username: string): boolean => {
	return username !== "admin" && typeof username === "string" && username.length >= 5 && /^[a-zA-Z0-9_\.]+$/.test(username);
};

export const isValidDisplayName = (displayName: any): boolean => {
	return typeof displayName === "string" && displayName.length >= 5;
};

export const isValidPassword = (password: string): boolean => {
	return typeof password === "string" && password.length >= 8 && password.indexOf(" ") < 0;
};

export const isJson = (str: any): boolean => {
	try {
		const result = JSON.parse(typeof str === "string" ? str : JSON.stringify(str));
		return typeof result === "object";
	} catch {
		return false;
	}
};

export const isAccountValid = (
	account: Partial<
		IAccountModel & {
			password: string;
			password2: string;
			codeMailConfirmation: string;
		}
	>,
): Record<keyof typeof account, { valid: boolean; message?: string }> => {
	return Object.fromEntries(
		Object.entries(account).map(([k, v]) => {
			if (typeof v !== "string") {
				return [k, { valid: true, message: undefined }];
			}

			switch (k) {
				case "email":
					return [k, { valid: isValidEmail(v), message: v === "" || isValidEmail(v) ? undefined : "Email inválido" }];
				case "password":
					return [
						k,
						{
							valid: isValidPassword(v),
							message:
								v === "" || isValidPassword(v)
									? undefined
									: "A senha deve conter pelo menos 8 caracteres, uma letra maiúscula, uma letra minúscula, um número e um caractere especial.",
						},
					];
				case "password2":
					return [k, { valid: v === account.password, message: v === "" || v === account.password ? undefined : "Senhas não conferem" }];
				case "username":
					return [k, { valid: isValidUsername(v), message: v === "" || isValidUsername(v) ? undefined : "Nome de usuário inválido" }];
			}

			return [k, { valid: true, message: undefined }];
		}),
	) as any;
};
